var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromoValentineLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "321px",
    height: "23px",
    viewBox: "0 0 321 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "promo-valentine-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-13",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-15",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-17",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-19",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-21",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-23",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-25",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-27",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-29",
    points: "0 19 172 19 172 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-31",
    points: "0 19 172 19 172 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "promo-valentine-logo"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#696969",
    fillRule: "nonzero",
    points: "180.062 17.9959677 181.162 17.9959677 177.602 12.9159677 180.722 8.43596768 179.642 8.43596768 177.042 12.1559677 174.482 8.43596768 173.362 8.43596768 176.482 12.9359677 172.942 17.9959677 174.022 17.9959677 177.042 13.6759677"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(190.007000, 0.000000)",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.468,16.4422677 C59.989,21.3383677 52.971,25.1632677 50.561,19.5529677 C50.444,19.2782677 50.362,18.9830677 50.252,18.6602677 C48.933,20.1023677 47.862,20.5623677 46.901,19.7658677 C46.104,19.1752677 45.012,16.6482677 44.669,15.8310677 C44.504,15.4396677 43.927,14.2242677 43.399,14.8147677 C41.833,16.2156677 41.043,21.5580677 38.496,19.5460677 C37.438,18.3031677 36.937,16.4971677 36.724,14.9040677 C36.346,12.0886677 33.483,19.0791677 32.673,19.8139677 C32.116,20.5005677 31.141,20.4456677 30.935,19.5392677 C30.516,17.8705677 30.798,15.4877677 31.292,13.8671677 C31.471,13.2766677 31.182,13.1736677 30.722,13.5100677 C29.603,14.3272677 28.69,15.3092677 27.426,15.9890677 C27.028,16.2019677 26.506,16.4216677 26.067,16.5177677 C25.538,19.6422677 21.809,22.9864677 20.655,18.3924677 C20.621,18.2482677 20.601,18.1040677 20.552,17.9667677 C20.484,17.7538677 20.381,17.7194677 20.23,17.8568677 C20.14,17.9392677 20.065,18.0422677 19.983,18.1383677 C18.781,19.4705677 17.407,21.0293677 15.67,21.6061677 C14.784,21.9014677 13.205,21.9838677 12.408,21.3795677 C10.451,19.8825677 10.966,16.1675677 10.774,14.1075677 C10.753,13.8671677 10.589,13.7572677 10.383,13.7916677 C10.135,13.8328677 9.923,13.9358677 9.717,14.1143677 C7.547,15.9821677 6.153,19.6902677 5.672,22.5125677 L3.996,22.5125677 C4.099,19.6559677 4.154,16.8061677 4.511,13.9632677 C2.877,15.2611677 1.346,16.1469677 0.288,16.5658677 L3.04040088e-23,15.5289677 C1.771,14.4645677 3.406,13.2697677 4.862,11.9238677 C5.486,8.57966768 5.905,5.57196768 7.341,2.42690768 C7.368,2.37197768 7.389,2.32390768 7.416,2.27583768 C9.112,-0.999672321 13.473,-0.951612321 11.832,3.81406768 C10.657,7.50846768 8.309,10.5298677 5.94,12.7341677 C5.658,14.4371677 5.486,16.0920677 5.383,17.8087677 C5.363,18.1727677 5.541,18.3237677 5.713,17.9255677 C6.537,16.0783677 8.872,12.0886677 11.152,12.6517677 C11.66,12.7753677 11.907,13.0705677 11.983,13.6542677 C12.216,15.5152677 11.674,20.9469677 14.633,20.6585677 C16.165,20.5074677 17.291,19.3744677 18.3,18.3237677 C18.987,17.6027677 20.14,15.9546677 20.552,15.0276677 C20.951,14.1212677 22.084,14.4645677 22.008,15.1581677 C21.946,15.7006677 21.892,16.2431677 21.843,16.7855677 C21.789,17.3349677 21.953,18.4336677 22.42,18.8182677 C22.75,19.0928677 23.038,19.0791677 23.347,18.7632677 C23.835,18.2551677 24.213,17.6645677 24.35,16.9091677 C24.412,16.5658677 24.384,16.4285677 24.103,16.3049677 C23.073,15.8448677 22.194,13.2834677 23.752,12.5555677 C25.744,11.6285677 26.328,13.8122677 26.3,15.3229677 C27.646,14.8834677 28.58,13.9632677 29.644,13.0362677 C31.684,11.2577677 33.38,11.5804677 32.494,14.6843677 C32.206,15.7074677 32.144,16.7718677 32.061,17.8293677 C32.02,18.3924677 32.199,19.0585677 32.57,18.2001677 C33.146,16.8817677 33.641,15.7006677 34.479,14.4989677 C35.124,13.5787677 35.584,12.9744677 36.697,12.9950677 C37.012,12.9950677 37.493,13.1942677 37.651,13.4894677 C38.372,14.8422677 38.097,16.4216677 39.073,18.1177677 C39.436,18.7563677 39.903,18.6602677 40.082,18.1177677 C40.714,16.6413677 42.121,13.6680677 43.824,13.4620677 C45.898,13.2079677 46.53,16.8061677 47.333,18.3306677 C48.309,19.9718677 50.43,16.9023677 50.581,16.4216677 C51.206,14.4233677 52.25,11.6560677 54.963,12.3289677 C57.201,13.2834677 54.303,18.9074677 51.948,18.9006677 C52.971,22.7872677 57.393,21.0087677 59.879,17.9667677 C60.463,17.2525677 61.005,16.4971677 61.445,15.6594677 C61.452,15.6388677 61.466,15.6250677 61.472,15.6044677 L62.509,16.4491677 L62.468,16.4422677 Z M8.391,2.91445768 C7.402,5.40716768 6.688,7.79686768 6.324,10.4474677 C8.062,8.55906768 9.476,6.41656768 10.472,4.00626768 C11.708,1.45180768 10.122,-0.264922321 8.391,2.91445768 Z M51.831,17.5684677 C52.882,17.9598677 55.313,13.7229677 54.228,13.4551677 C53.411,13.4345677 52.909,14.0456677 52.566,14.8010677 C52.326,15.3298677 51.563,17.0465677 51.831,17.5684677 Z M24.872,15.3092677 C25.153,14.6568677 24.995,14.1967677 24.81,13.8053677 C24.535,13.3040677 24.192,13.6542677 24.233,13.9770677 C24.281,14.4508677 24.274,15.1100677 24.872,15.3092677 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "85.802 13.3177677 85.026 13.3177677 87.635 20.4524677 88.425 20.4455677 90.671 14.3271677 92.895 20.4318677 93.665 20.4318677 96.253 13.3177677 95.56 13.3177677 93.28 19.7039677 91.014 13.3108677 90.293 13.3108677 88.082 19.6558677"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "114.849 13.3177677 114.176 13.3177677 114.176 20.4387677 114.849 20.4387677"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "125.939 13.3177677 125.266 13.3177677 125.266 20.4387677 125.939 20.4387677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.629,20.4318677 L85.026,13.3177677 L85.802,13.3177677 L88.082,19.6284677 L90.293,13.3108677 L91.014,13.3108677 L93.246,19.6215677 L95.498,13.3108677 L96.246,13.3108677 L93.699,20.4318677 L92.834,20.4318677 L90.671,14.3271677 L88.507,20.4318677 L87.629,20.4318677 Z M102.351,13.3108677 L106.897,19.3674677 L106.897,13.3108677 L107.57,13.3108677 L107.57,20.4318677 L106.897,20.4318677 L102.351,14.4439677 L102.351,20.4318677 L101.678,20.4318677 L101.678,13.3108677 L102.351,13.3108677 Z M114.176,13.3108677 L119.024,13.3108677 L119.024,13.9082677 L114.849,13.9082677 L114.849,16.5726677 L117.932,16.5726677 L117.932,17.1700677 L114.849,17.1700677 L114.849,19.8413677 L119.024,19.8413677 L119.024,20.4249677 L114.176,20.4249677 L114.176,13.3108677 Z M125.939,13.9082677 L125.939,18.1726677 L128.178,18.1726677 C129.4,18.1726677 130.313,17.2730677 130.313,16.0439677 C130.313,14.7391677 129.475,13.9082677 128.178,13.9082677 L125.939,13.9082677 Z M125.266,13.3108677 L128.15,13.3108677 C129.894,13.3108677 131.069,14.5331677 130.986,16.0576677 C130.876,18.0078677 129.469,18.4885677 129.469,18.4816677 L130.608,20.4318677 L129.867,20.4318677 L128.871,18.7013677 C128.624,18.7769677 128.432,18.7906677 128.15,18.7906677 L125.939,18.7906677 L125.939,20.4318677 L125.266,20.4318677 L125.266,13.3177677 L125.266,13.3108677 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.493,13.3383677 C69.795,12.9950677 70.722,12.7272677 71.333,12.4250677 L74.217,10.9967677 C74.554,10.8250677 74.794,10.8388677 75.083,11.0448677 L79.024,13.1392677 C79.367,13.3795677 79.525,13.5718677 79.512,14.0937677 C79.402,14.9589677 79.422,17.1632677 79.491,18.0902677 C79.608,18.8868677 79.491,19.7932677 79.512,20.6104677 C79.47,21.0979677 79.374,21.2353677 78.894,21.2765677 C76.868,21.4344677 71.244,21.4069677 70.083,21.2353677 C69.52,21.1460677 69.479,20.7202677 69.465,20.4593677 C69.41,19.0104677 69.253,17.5065677 69.479,16.2087677 C69.603,15.2542677 69.074,14.0319677 69.479,13.3314677 L69.493,13.3383677 Z M70.042,15.7349677 C70.042,17.1151677 69.932,18.6327677 70.015,20.1503677 C70.022,20.3082677 70.056,20.5692677 70.406,20.6310677 C71.601,20.6790677 73.05,20.4524677 74.087,20.5348677 C75.591,20.7065677 76.985,20.8438677 78.557,20.7065677 C78.681,20.6928677 78.983,20.6653677 78.928,20.3563677 C78.928,19.3194677 78.997,18.5366677 78.873,17.5340677 C78.743,16.4628677 78.969,15.2130677 78.997,14.1486677 C79.045,13.8533677 78.846,13.7091677 78.605,13.5718677 L74.842,11.5529677 C74.657,11.4430677 74.602,11.4499677 74.464,11.5392677 L71.567,12.9332677 C69.431,13.9632677 70.042,13.2628677 70.042,15.7349677 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.63,13.4070677 C69.926,13.0774677 70.825,12.8164677 71.423,12.5211677 L74.224,11.1340677 C74.554,10.9692677 74.781,10.9761677 75.069,11.1821677 L78.908,13.2216677 C79.237,13.4550677 79.395,13.6404677 79.381,14.1486677 C79.272,14.9932677 79.292,17.1357677 79.361,18.0353677 C79.471,18.8112677 79.361,19.6902677 79.375,20.4868677 C79.34,20.9606677 79.244,21.0979677 78.77,21.1322677 C76.799,21.2902677 71.327,21.2558677 70.2,21.0979677 C69.651,21.0155677 69.61,20.5966677 69.603,20.3425677 C69.548,18.9348677 69.397,17.4722677 69.617,16.2018677 C69.733,15.2679677 69.225,14.0799677 69.617,13.4070677 L69.63,13.4070677 Z M70.166,15.7417677 C70.166,17.0876677 70.056,18.5572677 70.139,20.0404677 C70.145,20.1983677 70.173,20.4456677 70.516,20.5074677 C71.677,20.5554677 73.091,20.3357677 74.101,20.4181677 C75.563,20.5898677 76.923,20.7202677 78.454,20.5829677 C78.571,20.5692677 78.866,20.5417677 78.818,20.2464677 C78.818,19.2370677 78.887,18.4747677 78.77,17.4996677 C78.64,16.4559677 78.86,15.2404677 78.894,14.2035677 C78.942,13.9151677 78.75,13.7778677 78.509,13.6404677 L74.842,11.6765677 C74.657,11.5735677 74.609,11.5804677 74.472,11.6628677 L71.656,13.0224677 C69.575,14.0250677 70.173,13.3452677 70.173,15.7486677 L70.166,15.7417677 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(0.000000, 3.995968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.140159,11.7885832 C161.43322,12.0621814 160.707167,12.1794378 160,12.1794378 C159.29306,12.1794378 158.567008,12.0621814 157.860068,11.7885832 L157.860068,3.21141685 C158.567008,2.93781857 159.29306,2.82056217 160,2.82056217 C160.707167,2.82056217 161.43322,2.93781857 162.140159,3.21141685 L162.140159,11.7885832 Z M160,2 C159.063709,2 158.012742,2.19542734 157,2.68376303 L157,12.3160043 C158.012742,12.8045727 159.063709,13 160,13 C160.936291,13 161.987258,12.8045727 163,12.3160043 L163,2.68376303 C161.987258,2.19542734 160.936291,2 160,2 L160,2 Z",
    id: "Fill-21",
    fill: "#696969",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.15732,15.9761847 C162.865091,16.7934501 161.404504,17.1827345 160.000111,17.1827345 C158.595496,17.1827345 157.134909,16.7934501 155.84268,15.9761847 L155.84268,2.02381535 C157.134909,1.20631815 158.595496,0.817265483 160.000111,0.817265483 C161.404504,0.817265483 162.865091,1.20631815 164.15732,2.02381535 L164.15732,15.9761847 Z M160.000111,0 C158.35199,0 156.572974,0.486373759 155,1.63453097 L155,16.365469 C156.572974,17.5133945 158.35199,18 160.000111,18 C161.64801,18 163.427026,17.5133945 165,16.365469 L165,1.63453097 C163.427026,0.486373759 161.64801,0 160.000111,0 L160.000111,0 Z",
    id: "Fill-23",
    fill: "#696969",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-25-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "160 10 161 10 161 7 160 7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-27-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6984463,2.88888889 L67.3015537,2.88888889 L66.1977401,17.2444894 L64.9489171,17.2444894 L66.1548964,1.75551057 L73.8451036,1.75551057 L75.0510829,17.2444894 L73.8020245,17.2444894 L72.6984463,2.88888889 Z M67.5,11.7665317 L68.1318267,3.64439946 L71.8681733,3.64439946 L72.5,11.7665317 L67.5,11.7665317 Z M67.0736817,17.2444894 L67.4411488,12.5222672 L72.5588512,12.5222672 L72.9260829,17.2444894 L67.0736817,17.2444894 Z M74.6753766,1 L65.3246234,1 L64,18 L76,18 L74.6753766,1 Z",
    id: "Fill-27",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-28-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.164925,11.1054881 C120.100304,9.85874944 120.549392,8.47998201 120.549392,6.98762933 C120.549392,5.57107512 120.15644,4.22986955 119.183637,2.88888889 L114.057878,2.88888889 L114.057878,17.2442645 L112.841819,17.2442645 L112.841819,1.75551057 L119.838335,1.75551057 C120.92341,3.0211426 121.765229,4.83445794 121.765229,6.98762933 C121.765229,8.36662168 121.391211,10.0098965 120.455832,11.3888889 L121.952349,17.2442645 L120.747874,17.2442645 L119.164925,11.1054881 Z M114.899696,10.8220873 L114.899696,3.64439946 L118.678635,3.64439946 C119.370757,4.66441745 119.707351,5.79779577 119.707351,6.98762933 C119.707351,8.40530814 119.217051,9.73684211 118.301944,10.8220873 L114.899696,10.8220873 Z M114.899696,17.2442645 L114.899696,11.5778228 L118.42825,11.5778228 L119.902491,17.2442645 L114.899696,17.2442645 Z M121.353787,11.540036 C122.158181,10.1988304 122.607047,8.61223572 122.607047,6.98762933 C122.607047,4.85335133 121.858789,2.75663518 120.287424,1 L112,1 L112,18 L123,18 L121.353787,11.540036 Z",
    id: "Fill-28",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-29-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-8)",
    points: "69 10 70 10 70 7 69 7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-30-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0726762,2.88888889 L58.3125,2.88888889 L55.5095687,6.43094917 L52.7066373,2.88888889 L50.9273238,2.88888889 L50.2160541,17.2444894 L48.8992254,17.2444894 L49.7601762,1.75551057 L53.3625456,1.75551057 L55.5,4.53216374 L57.6374544,1.75551057 L61.2398238,1.75551057 L62.1007746,17.2444894 L60.7837181,17.2444894 L60.0726762,2.88888889 Z M58.459675,17.2444894 L58.3125,11.5022492 L55.5,13.674314 L52.6875,11.5022492 L52.540325,17.2444894 L51.0596902,17.2444894 L51.7308627,3.64439946 L52.2651124,3.64439946 L55.5,7.70557805 L58.7346598,3.64439946 L59.2691373,3.64439946 L59.940082,17.2444894 L58.459675,17.2444894 Z M62.0433627,1 L57.2219016,1 L55.5095687,3.27125506 L53.7972357,1 L48.9566373,1 L48,18 L53.3762151,18 L53.4819259,13.0789474 L55.5,14.6754386 L57.5180741,13.0789474 L57.6237849,18 L63,18 L62.0433627,1 Z",
    id: "Fill-30",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-31-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.940728,15.3556005 L126.886445,15.3556005 L126.886445,3.64462438 L132.752245,3.64462438 L132.324057,7.98897886 L128.28299,7.98897886 L128.28299,8.74448943 L132.249551,8.74448943 L132.119165,10.0668016 L128.28299,10.0668016 L128.28299,10.8223122 L133.124775,10.8223122 L132.940728,15.3556005 Z M132.864004,17.2444894 L124.837971,17.2444894 L124.837971,1.75573549 L132.93851,1.75573549 L132.826751,2.88888889 L126.048473,2.88888889 L126.048473,16.1111111 L132.910127,16.1111111 L132.864004,17.2444894 Z M132.975763,10.0668016 L133.869614,1 L124,1 L124,18 L133.664723,18 L134,10.0668016 L132.975763,10.0668016 Z",
    id: "Fill-31",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-32-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.035184,2.88888889 L99.9045,2.88888889 L99.9045,1.75551057 L110.075395,1.75551057 L110.035184,2.88888889 Z M109.854236,7.98875394 L106.798947,7.98875394 L107.080421,17.2444894 L105.45237,17.2444894 L105.45237,3.64439946 L110.008377,3.64439946 L109.854236,7.98875394 Z M104.54787,17.2444894 L102.919579,17.2444894 L103.201053,7.98875394 L99.9045,7.98875394 L99.9045,3.64439946 L104.54787,3.64439946 L104.54787,17.2444894 Z M111,1 L99,1 L99,8.74448943 L102.276448,8.74448943 L101.994974,18 L108.005026,18 L107.723552,8.74448943 L110.738631,8.74448943 L111,1 Z",
    id: "Fill-32",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-33-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3512943,17.2444894 L88.8245663,17.2444894 L88.8719404,16.1111111 L95.5986428,16.1111111 C95.8316724,15.5445344 96.0286379,14.845704 96.0286379,13.8823662 C96.0286379,12.6167341 95.5986428,11.4077823 94.2006786,10.0668016 L92.2116045,8.17791273 C91.2796995,7.29014845 90.849491,6.59109312 90.849491,5.53351327 C90.849491,4.87224471 91.0287446,4.21120108 91.3872517,3.64462438 L96.501099,3.64462438 L96.7635774,7.98897886 L94.3620068,7.98897886 L94.8101406,8.49887539 C96.6560253,10.5955915 97.1935725,12.0690508 97.1935725,13.8823662 C97.1935725,15.4311741 96.6560253,16.6590193 96.3512943,17.2444894 L96.3512943,17.2444894 Z M89.0932332,10.8223122 L91.4589531,10.8223122 L90.3119438,9.36774629 C89.2904121,8.04565902 88.8602036,6.98785425 88.8781289,5.53351327 C88.8960543,4.38124157 89.2187107,2.96446244 90.2940185,1.75573549 L96.387145,1.75573549 L96.4556454,2.88888889 L90.9032671,2.88888889 C90.2760931,3.77665317 90.0430635,4.66441745 90.0430635,5.53351327 C90.0430635,6.9122807 90.5808241,7.76225821 91.7634707,8.89563653 L93.7169074,10.765632 C94.881842,11.880117 95.2222104,12.8623482 95.2222104,13.8823662 C95.2222104,14.6378767 95.0788075,15.1288799 95.0073195,15.3556005 L88.9035232,15.3556005 L89.0932332,10.8223122 Z M96.1182647,8.74448943 L97.6058556,8.74448943 L97.1397964,1 L89.86381,1 C88.609462,2.32231219 88.0717014,3.96558704 88.0717014,5.53351327 C88.0717014,7.17678812 88.555686,8.55555556 89.8458846,10.0668016 L88.3226564,10.0668016 L88,18 L96.8709161,18 C97.3907514,17.1122357 98,15.525641 98,13.8823662 C98,11.6533963 97.2294232,10.2555106 96.1182647,8.74448943 L96.1182647,8.74448943 Z",
    id: "Fill-33",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-34-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.944439,15.3556005 L147.876332,15.3556005 L147.876332,1.75573549 L149.472158,1.75573549 L149.175178,10.8223122 L153.127842,10.8223122 L152.944439,15.3556005 Z M152.867984,17.2444894 L145.835036,17.2444894 L145.835036,1.75573549 L147.041296,1.75573549 L147.041296,16.1111111 L152.913945,16.1111111 L152.867984,17.2444894 Z M150.028775,10.0668016 L150.325755,1 L145,1 L145,18 L153.665897,18 L154,10.0668016 L150.028775,10.0668016 Z M81.2750271,7.9888464 L81.2750271,8.74436697 L85.2512561,8.74436697 L85.3785219,10.0666967 L81.2750271,10.0666967 L81.2750271,10.8222172 L85.4515615,10.8222172 L85.8884708,15.3555656 L79.8810783,15.3555656 L79.8810783,3.64443445 L85.8172019,3.64443445 L86.0892189,7.9888464 L81.2750271,7.9888464 Z M77.8364135,17.2444794 L77.8364135,1.75552057 L85.6987893,1.75552057 L85.7698369,2.88891388 L79.0444435,2.88891388 L79.0444435,16.1110861 L85.961289,16.1110861 L86.070627,17.2444794 L77.8364135,17.2444794 Z M86.1078108,8.74436697 L86.9814081,8.74436697 L86.4794272,1 L77,1 L77,18 L87,18 L86.1078108,8.74436697 Z",
    id: "Fill-34",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-36-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.821482,17.2444894 L135.821482,1.75573549 L137.008164,1.75573549 L137.008164,16.1111111 L143.133303,16.1111111 L143.178518,17.2444894 L135.821482,17.2444894 Z M137.829646,1.75573549 L139.39957,1.75573549 L139.10741,10.8223122 L142.922878,10.8223122 L143.103304,15.3556005 L137.829646,15.3556005 L137.829646,1.75573549 Z M143.67132,10.0668016 L139.947152,10.0668016 L140.239312,1 L135,1 L135,18 L144,18 L143.67132,10.0668016 Z",
    id: "Fill-36",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-20)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-37-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-22)",
    points: "16 1 9 1 9.30860505 7.98875394 10.8095376 7.98875394 10.8095376 10.8220873 9.30860505 10.8220873 9 18 15.6668596 18 15.3591549 10.8220873 13.880957 10.8220873 13.880957 7.98875394 15.3818895 7.98875394"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-38-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-24)",
    points: "18.3002643 7.9888464 20.9590025 7.9888464 18.3002643 10.8222172 18 18 24.6997357 18 24.3591516 10.8222172 22.0409975 10.8222172 24.6997357 7.9888464 25 1 18.3002643 1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-39-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-26)",
    points: "27.3090155 7.9888464 29.8320044 7.9888464 27.3090155 10.8222172 27 18 33.3745418 18 33.0655263 10.8222172 30.8587551 10.8222172 33.3817439 7.9888464 34 1 27.3090155 1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-40-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63735741,10.4444444 L3.13070342,10.4444444 L3.13070342,7.98897886 L4.63735741,7.98897886 L4.63735741,10.4444444 Z M0,1 L0,18 L3.80964829,18 L3.64187262,13.4275753 L6.09458175,13.4239766 C6.09576996,13.4226271 6.09648289,13.4212776 6.09743346,13.419928 L6.42419202,13.419928 C7.43559886,11.8396311 8,9.68533513 8,7.77103014 C8,5.65159694 7.43845057,3.06995052 5.46292776,1 L0,1 Z",
    id: "Fill-40",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-41-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5,10.4444444 L38.7936021,10.4444444 L38.7936021,7.98897886 L39.5,7.98897886 L40.2063979,7.98897886 L40.2063979,10.4444444 L39.5,10.4444444 Z M44,18 L42.7088739,1 L39.5,1 L36.2911261,1 L35,18 L38.7936021,18 L38.6367238,13.4275753 L39.5,13.4275753 L40.3634991,13.4275753 L40.2063979,18 L44,18 Z",
    id: "Fill-41",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-30)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-42-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#696969",
    fillRule: "nonzero",
    mask: "url(#mask-32)",
    points: "117 9 118 9 118 6 117 6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoValentineLogo);
export default __webpack_public_path__ + "static/media/promo-valentine-logo.3fb57f0053da0d65c72addc79e037ab6.svg";
export { ForwardRef as ReactComponent };